import FirstScreen from "../../components/News/FirstScreen/FirstScreen";
import { fetchGlobalData } from "../../utils/utils";
import { useQuery } from "@tanstack/react-query";
import { shouldShowQueryLoading } from "../../utils/queryHydration";
import ContactUkraine from "../../components/News/ContactUkraine/ContactUkraine.tsx";
import { NewsUkraine_Plain } from "../../types/api/news-ukraine.ts";
import NewsListUkraine from "../../components/News/NewsListUkraine/NewsListUkraine.tsx";

const NewsUkraine = ({ locale }: { locale: string }) => {
  const {
    data: page,
    error,
    isLoading,
    isError,
  } = useQuery<NewsUkraine_Plain>({
    queryKey: ["/api/news-ukraine?customPopulate=nested&locale=" + locale],
    queryFn: ({ queryKey }) => fetchGlobalData(queryKey[0] as string),
  });

  if (shouldShowQueryLoading(isLoading, page))
    return <div className="loading-block"></div>;
  if (isError) return <div>Error: {error.message}</div>;
  if (!page) return <div>Global error: {page}</div>;

  return (
    <>
      <div className="parallax-content-block">
        <div className="parallax-content-block__wrap">
          <FirstScreen data={page} />
        </div>
      </div>
      <div className="content-block">
        <NewsListUkraine locale={locale} />
        <ContactUkraine data={page} />
      </div>
    </>
  );
};

export default NewsUkraine;
